import { render, staticRenderFns } from "./CocDetail.vue?vue&type=template&id=0dbd419e&scoped=true"
import script from "./CocDetail.vue?vue&type=script&lang=js"
export * from "./CocDetail.vue?vue&type=script&lang=js"
import style0 from "./CocDetail.vue?vue&type=style&index=0&id=0dbd419e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbd419e",
  null
  
)

export default component.exports